<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="" >
                <el-input placeholder="请输入代理商账号" v-model="oldAgentForm.accountName" class="input-with-select">
                    <template slot="prepend">旧代理商：</template>
                    <el-button slot="append" class="agent-change-search-button" icon="el-icon-search" @click="selectAgentByAccountNameHandel('oldAgentForm',oldAgentForm.accountName)"></el-button>
                </el-input>
                <div v-show="oldAgentForm.id.length > 0">
                    <p >代理商名称：{{oldAgentForm.name}}</p>
                    <p >代理商ID：{{oldAgentForm.id}}</p>
                    <p >代理商路径：{{oldAgentForm.pathNames}}</p>
                </div>
            </el-form-item>
            <span class="symbol-defind">=></span>
            <el-form-item label="">
                <el-input placeholder="请输入代理商账号" v-model="newAgentForm.accountName" class="input-with-select">
                    <template slot="prepend">新代理商：</template>
                    <el-button slot="append" class="agent-change-search-button" icon="el-icon-search" @click="selectAgentByAccountNameHandel('newAgentForm',newAgentForm.accountName)"></el-button>
                </el-input>
                <div v-show="newAgentForm.id.length > 0">
                    <p >代理商名称：{{newAgentForm.name}}</p>
                    <p >代理商ID：{{newAgentForm.id}}</p>
                    <p >代理商路径：{{newAgentForm.pathNames}}</p>
                </div>
            </el-form-item>

            <el-form-item label="迁移类型：">
                <el-radio v-model="type" label="0">替换</el-radio>
                <el-radio v-model="type" label="1">迁移</el-radio>
            </el-form-item>


            <el-form-item class="btnArea">
                <el-button type="primary" @click="showRemovalVisible" style="margin-left: 20px;">层级迁移</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="oldAgentName" label="旧代理商"></el-table-column>
            <el-table-column prop="oldAgentPathNames" label="旧代理商层级关系"></el-table-column>
            <el-table-column prop="newAgentName" label="新代理商"></el-table-column>
            <el-table-column prop="newAgentPathNames" label="新代理商层级关系"></el-table-column>
            <el-table-column prop="typeName" label="迁移类型"></el-table-column>
            <el-table-column prop="remark" label="迁移原因"></el-table-column>
            <el-table-column prop="createTime" label="迁移时间" width="140px"></el-table-column>
            <el-table-column prop="createOptName" label="操作人"></el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true"  title="层级迁移" :visible.sync="removalVisible" width="30%" :close-on-click-modal="false">
            <div class="removalDialog">
                <label width="150">旧代理商名称：</label>
                <span>{{oldAgentForm.name}}</span>
            </div>
 
            <div class="removalDialog">
                <label>旧代理商ID：</label>
                <span>{{oldAgentForm.id}}</span>
            </div>
            <div class="removalDialog">
                <label>新代理商名称：</label>
                <span>{{newAgentForm.name}} </span>
            </div>
 
            <div class="removalDialog">
                <label>新代理商ID：</label>
                <span>{{newAgentForm.id}}</span>
            </div>

            <div class="removalDialog">
                <label>迁移原因：</label>
                <el-input
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="removalForm.remark"
                      maxlength="200"
                      show-word-limit
                >
                </el-input>
                
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button  @click="removalVisible = false">取 消</el-button>
                <el-button type="primary" @click="removalHandler()">确 定</el-button>
            </span>            
        </el-dialog> 

    </div>
</template>
<script>
import {selectAgentByAccountName, getAgentChangeList, doAgentChange} from '@/api/customers.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
            },
            oldAgentForm:{
                id: '',
                accountName:'',
                name: '',
                pathNames:'',
            },
            newAgentForm:{
                id: '',
                accountName:'',
                name: '',
                pathNames:'',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            removalForm: {
                remark:'',
            },
            type:'0',
            removalVisible: false,
        };
    },
    methods: {
        selectAgentByAccountNameHandel(AgentForm, accountName){
            let fd = new FormData();
            fd.append("sysUserAccountName",accountName);
            selectAgentByAccountName(fd).then(res => {  //获取往期来往订单
                if(res.data.code == 200){
                    if(AgentForm=="oldAgentForm"){
                        this.oldAgentForm = res.data.data;
                    }else if(AgentForm=="newAgentForm"){
                        this.newAgentForm = res.data.data;
                    }

                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        getAgentChangeListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getAgentChangeList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        removalHandler(){
            this.$confirm('确定要进行此操作吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let fd = new FormData();
                fd.append("oldAgentId", this.oldAgentForm.id)
                fd.append("newAgentId", this.newAgentForm.id)
                fd.append("remark", this.removalForm.remark);
                fd.append("type", this.type);
                doAgentChange(fd).then(res => {  //获取往期来往订单
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentChangeListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                    this.removalVisible = false;
                    this.removalForm.remark = '';
                })
            }).catch(() => {

            });
        },

        showRemovalVisible(){
            if(this.oldAgentForm.id.trim().length < 1){
                this.$message.error('请先输入搜索旧代理商');
                return;
            }
            if(this.newAgentForm.id.trim().length < 1){
                this.$message.error('请先输入搜索新代理商');
                return;
            }




            this.removalVisible = true;
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentChangeListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentChangeListHandler();
        }, 

    },
    created () {
        this.getAgentChangeListHandler();
    } 
}
</script>
<style lang="less">

    .removalDialog {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-bottom: 18px;
    }

    .removalDialog label {
        width: 120px;
        padding-right: 12px;
        text-align: right;
        -ms-flex-negative: 0;
        flex-shrink: 0;
    }

    .symbol-defind{
        display: inline-block;
        height: 32px;
        line-height: 32px;
        text-align: center;
        width: 32px;
        margin-right: 10px;
        color: #409EFF;
    }

    .agent-change-search-button{
        color: #409EFF !important;
    }
</style>

